import type { FactoryDocument } from '@indutrust/factory-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Standard CRUD events for a factory's documents collection.
 *
 * Backed by {@link import('../factory-document-api-client.service').FactoryDocumentApiClient}
 * at `/factories/{factoryId}/documents`. Dispatchers must always pass
 * `urlSegments: { factoryId }` so the request resolves the parent
 * factory.
 *
 * Source namespace: `factory.document` — keeps the Redux DevTools
 * trace grouped with the other factory sub-resources.
 *
 * @example
 * const dispatch = injectDispatch(factoryDocumentCrudEvents);
 * dispatch.loadAllRequested({ urlSegments: { factoryId: 7 } });
 */
export const factoryDocumentCrudEvents =
  createCrudEvents<FactoryDocument>('factory.document');
